import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=41fd5836"
import script from "./LicenseInfo.vue?vue&type=script&lang=js"
export * from "./LicenseInfo.vue?vue&type=script&lang=js"
import style0 from "./LicenseInfo.vue?vue&type=style&index=0&id=41fd5836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports